import { gql } from '@apollo/client/core'

export const HOLE_FRAGMENT = gql`
  fragment Hole on Hole {
    id
    position
    par
    map
    gallery
    galleryPaths
    description
  }
`
